function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 5.85715C15.0977 5.85715 16.3929 4.70588 16.3929 3.28572C16.3929 1.86556 15.0977 0.714294 13.5 0.714294C11.9023 0.714294 10.6071 1.86556 10.6071 3.28572C10.6071 4.70588 11.9023 5.85715 13.5 5.85715Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.85714 21.2857C5.45482 21.2857 6.75 20.1344 6.75 18.7143C6.75 17.2941 5.45482 16.1429 3.85714 16.1429C2.25946 16.1429 0.964287 17.2941 0.964287 18.7143C0.964287 20.1344 2.25946 21.2857 3.85714 21.2857Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 21.2857C15.0977 21.2857 16.3929 20.1344 16.3929 18.7143C16.3929 17.2941 15.0977 16.1429 13.5 16.1429C11.9023 16.1429 10.6071 17.2941 10.6071 18.7143C10.6071 20.1344 11.9023 21.2857 13.5 21.2857Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1429 21.2857C24.7405 21.2857 26.0357 20.1344 26.0357 18.7143C26.0357 17.2941 24.7405 16.1429 23.1429 16.1429C21.5452 16.1429 20.25 17.2941 20.25 18.7143C20.25 20.1344 21.5452 21.2857 23.1429 21.2857Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.85715 16.1429V12.7143C3.85715 12.2596 4.06034 11.8236 4.42201 11.5021C4.78369 11.1806 5.27423 11 5.78572 11H21.2143C21.7258 11 22.2163 11.1806 22.578 11.5021C22.9397 11.8236 23.1429 12.2596 23.1429 12.7143V16.1429M13.5 5.85715V16.1429",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgOrganizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/Organizations.ff678342.svg";
export { ForwardRef as ReactComponent };